import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inr = (v) => (v >= 1e7 ? `₹${+(v / 1e7).toFixed(1)} Cr` : v >= 1e5 ? `₹${+(v / 1e5).toFixed(1)} L` : `₹${Number(v).toLocaleString("en-IN")}`);

export function PropertyDeskTeaser() {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/property-desk/landing`).then((r) => setD(r.data)).catch(() => setD({ curated: [], counters: {} })); }, []);
  const picks = (d?.curated || []).slice(0, 3);
  const bg = d?.hero?.photos?.[0]?.url;
  return (
    <section id="property-desk" className="relative overflow-hidden bg-[#0A0A0A] text-[#F5F5F0]" data-testid="pd-teaser" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&display=swap" rel="stylesheet" />
      <div className="absolute inset-0">
        {bg && <img src={bg} alt="" className="w-full h-full object-cover opacity-50 scale-105" loading="lazy" />}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/60" />
      </div>
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 grid lg:grid-cols-[1fr_1.1fr] gap-14 items-center">
        <div>
          <div className="font-grotesk text-[10px] uppercase tracking-[0.36em] text-[#C9A84C] mb-6 inline-flex items-center gap-3">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"><path d="M6 3h12l4 6-10 12L2 9l4-6z" /><path d="M2 9h20" /></svg>
            Vinci Property Desk
          </div>
          <h2 className="text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-wide font-light">Exceptional Properties.<br /><span className="text-[#C9A84C] italic">Verified Network.</span></h2>
          <p className="font-body text-[#9A9A8A] text-base md:text-lg mt-7 max-w-lg leading-relaxed">
            A by-invitation collection of {d?.counters?.properties || "—"} exceptional properties across {d?.counters?.cities || "—"} cities — penthouses, estates, trophy floors and heritage houses, presented to verified members and Verified Property Partners.
          </p>
          <Link to="/property-desk" data-testid="pd-teaser-cta"
                className="group relative inline-flex items-center gap-3 mt-10 border border-[#C9A84C] text-[#C9A84C] hover:text-[#0A0A0A] px-8 py-4 font-grotesk text-[11px] uppercase tracking-[0.3em] overflow-hidden transition-colors duration-300">
            <span className="absolute inset-0 bg-[#C9A84C] -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out" />
            <span className="relative">Enter the Property Desk →</span>
          </Link>
        </div>
        <div className="grid grid-cols-3 gap-3 md:gap-4" data-testid="pd-teaser-picks">
          {picks.map((p, i) => (
            <Link key={p.id} to={`/property-desk/p/${p.slug}`} className={`group relative overflow-hidden border border-transparent hover:border-[#C9A84C] transition-colors duration-500 ${i === 1 ? "mt-10" : ""}`} data-testid={`pd-teaser-pick-${p.id}`}>
              <div className="aspect-[3/4] overflow-hidden bg-[#111]">{p.photos?.[0]?.url && <img src={p.photos[0].url} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-[600ms] group-hover:scale-105" />}</div>
              <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[#0A0A0A] to-transparent">
                <div className="font-grotesk text-[9px] uppercase tracking-[0.28em] text-[#C9A84C]">{p.city}</div>
                <div className="text-lg leading-tight mt-1 line-clamp-2">{p.title}</div>
                <div className="text-[#C9A84C] text-base mt-1">{inr(p.price_inr)}{p.deal_type === "lease" ? "/mo" : ""}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
